import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/shared/api/queryKeys';
import { fetchBrief, fetchDocument, fetchWhatChanged } from '../api/documentsApi';

/** Written by the model on first open (a few seconds), then stored, so it never goes stale in a session. */
export function useBriefQuery(id: string) {
  return useQuery({
    queryKey: queryKeys.documents.brief(id),
    queryFn: ({ signal }) => fetchBrief(id, signal),
    staleTime: Infinity,
    retry: false,
  });
}

export function useDocumentQuery(id: string) {
  return useQuery({
    queryKey: queryKeys.documents.detail(id),
    queryFn: ({ signal }) => fetchDocument(id, signal),
    staleTime: 10 * 60_000,
  });
}

export function useWhatChangedQuery(id: string, enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.documents.whatChanged(id),
    queryFn: ({ signal }) => fetchWhatChanged(id, signal),
    enabled,
    staleTime: 10 * 60_000,
  });
}
